import React, { useEffect, useMemo, useState } from "react";
import { Navigate } from "react-router-dom";
import Select from "react-select";
import { all_routes } from "../../../router/backendComponents/admin/all_routes";
import { isAuthenticated } from "../../../authentication/backendModule/admin/auth";
import apiRequestCall from "../../../apiHelper/globalHelper";
import { parseValidationErrors } from "../../../apiHelper/validationHelper";
import Export from "../../../formHelper/export";
import Search from "../../../formHelper/search";
import Pagination from "../../../formHelper/pagination";
import Table from "../../../formHelper/list";
import DateRangePicker from "react-bootstrap-daterangepicker";
import Success from "../../../formHelper/success";
import Delete from "../../../formHelper/delete";
import exportApiCall from "../../../apiHelper/export";
import FilterDropdown from "../../../formHelper/filterDropDown";
import Loader from "../../../formHelper/Loader";
import dayjs from "dayjs";
import type { RootState, AppDispatch } from "../../../core/data/redux/store";
import { useDispatch, useSelector } from "react-redux";
interface Customer {
  id: number;
  gst_number: string;
  company_name: string;
  customer_name: string;
  email_id: string;
  mobile_no: string;
  landline_no: string;
  address: string;
  owner_id: number;
  country_id: number;
  classification_id: number;
  state_id: number;
  other_state: string;
  pin_code: string;
  state_dd: string;
  gst_field: boolean;
  other_state_field: boolean;
  branch?: { id: number; name: string } | null;
  classification?: { id: number; name: string } | null;
  owner?: { id: number; name: string } | null;
  state?: { id: number; name: string } | null;
  country?: { id: number; name: string } | null;
  created_at?: string;
  city?: string;
}

interface KV {
  id: number;
  name: string;
}

interface PermissionList {
  id: number;
  role_id: number;
  name: string;
  role: {
    permissions: Record<string, Record<string, string>>;
  };
}

const Customer: React.FC = () => {
  const backendRoute = all_routes.backend;

  const [list, setList] = useState<Customer[]>([]);
  const [formData, setFormData] = useState<any>({
    gst_number: "",
    company_name: "",
    customer_name: "",
    email_id: "",
    mobile_no: "",
    landline_no: "",
    address: "",
    owner_id: "",
    country_id: "",
    classification_id: "",
    state_id: "",
    other_state: "",
    pin_code: "",
    state_dd: "India",
    gst_field: false,
    other_state_field: false,
    city: "",
  });

  const [formError, setFormError] = useState<{ [k: string]: string }>({});
  const [selectedId, setSelectedId] = useState<number | null>(null);

  const [branchList, setBranchList] = useState<KV[]>([]);
  const [classificationList, setClassificationList] = useState<KV[]>([]);
  const [countryList, setCountryList] = useState<KV[]>([]);
  const [stateList, setStateList] = useState<KV[]>([]);
  const [ownerList, setOwnerList] = useState<KV[]>([]);

  const [showForm, setShowForm] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const [showMessage, setShowMessage] = useState("");
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteId, setDeleteId] = useState<number | null>(null);

  const [query, setQuery] = useState("");
  const [startDate, setStartDate] = useState<string>("");
  const [endDate, setEndDate] = useState<string>("");

  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState<number>(() =>
    typeof window !== "undefined" && window.innerWidth <= 768 ? 5 : 10,
  );
  const [totalItems, setTotalItems] = useState(0);
  const [loading, setLoading] = useState(false);

  const [selectedCountryName, setSelectedCountryName] = useState("India");

  // filters
  const [ownerFilter, setOwnerFilter] = useState<number[]>([]);
  const [branchFilter, setBranchFilter] = useState<number[]>([]);

  // export/polling states
  const [exporting, setExporting] = useState(false);
  const [downloading, setDownloading] = useState(false);

  // request guards
  const [submitting, setSubmitting] = useState(false);
  const [deleting, setDeleting] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [loadingSearch, setLoadingSearch] = useState(false);

  /* ------------------- Helpers: download & poll ------------------- */
  /** ---------- Export Helpers ---------- **/
  const triggerDownload = (url: string, filename: string, revoke = false) => {
    if (!url) return;

    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();

    setDownloading(true);
    setTimeout(() => setDownloading(false), 3000);
    setExporting(false);
  };

  // Poll API for local download
  const pollForFile = (filename: string) => {
    let attempts = 0;
    const maxAttempts = 60;

    const interval = setInterval(async () => {
      attempts++;
      try {
        const res = await exportApiCall("get", `/download-export/${filename}`, {
          responseType: "blob",
        });

        if (res) {
          clearInterval(interval);
          setExporting(false);
          setDownloading(true);

          const blob = new Blob([res], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          const url = window.URL.createObjectURL(blob);
          triggerDownload(url, filename, true);

          setTimeout(() => setDownloading(false), 3000);
        }
      } catch (err: any) {
        if (err?.response?.status !== 404) {
          clearInterval(interval);
          setExporting(false);
          setDownloading(false);
          alert("Export failed while downloading.");
        } else if (attempts >= maxAttempts) {
          clearInterval(interval);
          setExporting(false);
          setDownloading(false);
          alert("Export took too long. Please try again later.");
        }
      }
    }, 5000);
  };

  /* ------------------- Export ------------------- */
  const exportFile = async () => {
    if (exporting || submitting || deleting) return;
    try {
      setExporting(true);
      setDownloading(false);

      const result = await apiRequestCall("post", backendRoute.getCustomer, {
        data: {
          search: searchText,
          start_date: startDate,
          end_date: endDate,
          branch_list: branchFilter,
          owner_list: ownerFilter,
          download: true,
        },
      });

      const filename = result?.data?.data?.file;
      const fileUrl = result?.data?.data?.url;

      if (!filename) {
        setExporting(false);
        alert("Export request failed. Please try again.");
        return;
      }

      pollForFile(filename);
    } catch (err) {
      console.error("Export request failed:", err);
      setExporting(false);
      setDownloading(false);
      alert("Export failed. Please try again.");
    }
  };

  /* ------------------- Form handlers ------------------- */
  const inputChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => {
    const { name, value } = e.target;
    setFormError((prev) => {
      const copy = { ...prev };
      delete copy[name];
      return copy;
    });
    setFormData((prev: any) => ({ ...prev, [name]: value }));
  };

  const resetForm = () => {
    setFormData({
      gst_number: "",
      company_name: "",
      customer_name: "",
      email_id: "",
      mobile_no: "",
      landline_no: "",
      address: "",
      owner_id: "",
      country_id: "",
      classification_id: "",
      state_id: "",
      other_state: "",
      pin_code: "",
      state_dd: "India",
      gst_field: false,
      other_state_field: false,
      city: "",
    });
    setFormError({});
    setSelectedId(null);
    setShowForm(false);
    setSelectedCountryName("India");
  };

  const handleSubmit = async () => {
    if (submitting) return;
    setSubmitting(true);
    try {
      const payload = {
        ...formData,
        customer_id: selectedId,
        update_status: !!selectedId,
      };

      const result = await apiRequestCall(
        "post",
        backendRoute.addUpdateCustomer,
        { data: payload },
      );

      if (result?.data?.code === 221) {
        setFormError(parseValidationErrors(result?.data?.errors));
        return;
      }

      if (result?.data?.code === 200) {
        resetForm();
        setShowSuccess(true);
        setShowMessage(result?.data?.message);
        fetchList({ page: currentPage, perPage, search: searchText });
        setSelectedCountryName("India");
      } else {
        setShowMessage(result?.data?.message || "Operation failed");
        setShowSuccess(true);
      }
    } catch (err) {
      console.error("Submit failed:", err);
      setShowMessage((err as any)?.message || "Submit failed. Please try.");
      setShowSuccess(true);
    } finally {
      setSubmitting(false);
    }
  };

  const updateRecord = (row: Customer) => {
    if (submitting || deleting) return;
    const selected = list.find((x) => x.id === row.id);
    if (!selected) return;
    setFormError({});
    const stateDd = selected.country?.name ?? "India";
    setSelectedCountryName(stateDd);
    setFormData({
      ...selected,
      state_dd: stateDd,
      gst_field: stateDd === "India",
    });
    setSelectedId(selected.id);
    setShowForm(true);
  };

  /* ------------------- Delete ------------------- */
  const deleteRecord = (id: number) => {
    if (submitting || deleting) return;
    setDeleteId(id);
    setShowDeleteModal(true);
  };

  const confirmDelete = async () => {
    if (!deleteId || deleting) return;
    setDeleting(true);
    try {
      const result = await apiRequestCall("post", backendRoute.deleteCustomer, {
        data: { id: deleteId },
      });
      if (result?.data?.code === 200) {
        fetchList({ page: currentPage, perPage, search: searchText });
        setShowMessage(result?.data?.message);
        setShowSuccess(true);
      } else {
        setShowMessage(result?.data?.message || "Delete failed");
        setShowSuccess(true);
      }
    } catch (err) {
      console.error("Delete failed:", err);
      alert("Delete failed. Please try again.");
    } finally {
      setDeleteId(null);
      setShowDeleteModal(false);
      setDeleting(false);
    }
  };

  /* ------------------- Fetch list & lookups ------------------- */
  const fetchList = async ({
    page = 1,
    perPage: p = 10,
    search = "",
  }: { page?: number; perPage?: number; search?: any } = {}) => {
    setLoading(true);
    if (search) {
      setLoadingSearch(true);
    }
    try {
      const result = await apiRequestCall("post", backendRoute.getCustomer, {
        data: {
          page,
          per_page: p,
          start_date: startDate,
          end_date: endDate,
          search: query.trim(),
          branch_list: branchFilter,
          owner_list: ownerFilter,
        },
      });

      const res = result?.data?.data;
      if (res) {
        setList(res.data ?? []);
        setCurrentPage(res.current_page ?? 1);
        setPerPage(res.per_page ?? 10);
        setTotalItems(res.total ?? 0);
      } else {
        setList([]);
        setTotalItems(0);
      }
    } catch (err) {
      console.error("Failed to fetch customers:", err);
      setList([]);
      setTotalItems(0);
    } finally {
      setLoadingSearch(false);
      setLoading(false);
    }
  };

  const getLookup = async (endpoint: string) => {
    try {
      const r = await apiRequestCall("post", endpoint);
      const raw = r?.data?.data;
      if (raw && typeof raw === "object") {
        return Object.entries(raw).map(([id, name]) => ({
          id: +id,
          name: String(name),
        }));
      }
    } catch (err) {
      console.error(`Failed to fetch ${endpoint}`, err);
    }
    return [] as KV[];
  };

  const getAllLookups = async () => {
    try {
      const [branches, owners, states, countries, classifications] =
        await Promise.all([
          getLookup(backendRoute.getBranchDD),
          getLookup(backendRoute.getOwnerDD),
          getLookup(backendRoute.getStateDD),
          getLookup(backendRoute.getCountryDD),
          getLookup(backendRoute.getClassificationDD),
        ]);
      setBranchList(branches);
      setOwnerList(owners);
      setStateList(states);
      setCountryList(countries);
      setClassificationList(classifications);
    } catch (err) {
      console.error("Failed to fetch lookups:", err);
    }
  };

  const searchTextData = (text: string) => {
    setSearchText(text);
  };

  useEffect(() => {
    fetchList({ page: currentPage, perPage, search: searchText });
  }, [
    ,
    currentPage,
    perPage,
    startDate,
    endDate,
    branchFilter,
    ownerFilter,
    searchText,
  ]);

  useEffect(() => {
    getAllLookups();
  }, []);

  const permission = useSelector(
    (state: RootState) => state.rolesPermissions?.data,
  ) as PermissionList | null;

  const permissionMap = useMemo(() => {
    return permission?.role?.permissions ?? {};
  }, [permission]);

  if (!isAuthenticated()) return <Navigate to="/login" replace />;

  const columns = [
    {
      key: "id",
      label: "Sr. No",
      render: (_: any, i: number) => (currentPage - 1) * perPage + i + 1,
    },
    { key: "gst_number", label: "GST" },
    { key: "company_name", label: "Company" },
    { key: "branch.name", label: "Branch" },
    { key: "owner.name", label: "Owner" },
    { key: "country.name", label: "Country" },
    {
      key: "created_at",
      label: "Date",
    },

    // { key: "customer_name", label: "Customer" },
    // { key: "pin_code", label: "Pincode" },
    // { key: "city", label: "City" },
    // { key: "address", label: "Address" },
    // { key: "other_state", label: "Other State" },
    // { key: "state.name", label: "State" },
    // { key: "email_id", label: "Email Id" },
    // { key: "mobile_no", label: "Mobile No." },
    // { key: "landline_no", label: "Landline No." },
    // { key: "classification.name", label: "Classification" },

    ...(permissionMap?.customer?.edit_customer ||
    permissionMap?.customer?.delete_customer
      ? [
          {
            key: "action",
            label: "Action",
            render: (row: Customer) => (
              <div className="hstack gap-2 fs-15">
                {permissionMap?.customer?.edit_customer && (
                  <button
                    className="btn btn-icon btn-sm btn-soft-info"
                    onClick={() => updateRecord(row)}
                    disabled={submitting || deleting}
                    aria-label={`Edit customer ${row.customer_name}`}
                  >
                    <i className="feather-edit" />
                  </button>
                )}

                {permissionMap?.customer?.delete_customer && (
                  <button
                    className="btn btn-icon btn-sm btn-soft-danger"
                    onClick={() => deleteRecord(row.id)}
                    disabled={submitting || deleting}
                    aria-label={`Delete customer ${row.customer_name}`}
                  >
                    <i className="feather-trash" />
                  </button>
                )}
              </div>
            ),
          },
        ]
      : []),
  ];

  /* ------------------- Render (Source-style) ------------------- */
  return (
    <div className="page-wrapper">
      <div className="content">
        {/* Header: Title | Export | New */}
        <div className="row page-header">
          <div className="col-12">
            <div className="d-flex align-items-start justify-content-between">
              <div className="d-flex align-items-center gap-2">
                <h4 className="page-title">
                  Customer
                  <span className="count-title">{totalItems}</span>
                </h4>
              </div>

              <div className="d-flex align-items-center gap-2">
                <div className="d-flex justify-content-end gap-2">
                  {permissionMap?.customer?.export_customer && (
                    <Export
                      options={[
                        {
                          label: downloading
                            ? "Downloading..."
                            : exporting
                              ? "Generating..."
                              : "Export",
                          iconClass: downloading
                            ? "ti ti-download"
                            : exporting
                              ? "ti ti-loader"
                              : "ti ti-file-type-xls",
                          colorClass:
                            exporting || downloading
                              ? "text-muted"
                              : "text-primary",
                          onClick:
                            exporting || downloading || submitting || deleting
                              ? undefined
                              : exportFile,
                        },
                      ]}
                    />
                  )}

                  {permissionMap?.customer?.add_customer && (
                    <button
                      className="btn btn-soft-success d-flex align-items-center"
                      onClick={() => {
                        resetForm();
                        setShowForm(true);
                      }}
                      disabled={submitting}
                      aria-label="Add new customer"
                    >
                      <i className="ti ti-square-rounded-plus" />
                      <span className="d-none d-md-inline ms-1">New</span>
                    </button>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Top Card: search / date / filter */}
        <div className="card mb-2">
          <div className="card-body">
            <div className="row g-2 align-items-center">
              <div className="col-12 col-md-4">
                <div className="icon-form position-relative">
                  <span className="form-icon">
                    <i className="ti ti-search" />
                  </span>
                  <Search
                    placeholder="Enter Text ..."
                    value={query}
                    onChange={setQuery}
                    searchText={searchTextData}
                    loading={loadingSearch}
                  />
                </div>
              </div>

              <div className="col-12 col-md-3">
                <FilterDropdown
                  label="Owner"
                  endpoint="/getOwnerDD"
                  selected={ownerFilter}
                  onChange={(v) => setOwnerFilter(v as number[])}
                />
              </div>

              <div className="col-12 col-md-3">
                <FilterDropdown
                  label="Branch"
                  endpoint="/getBranchDD"
                  selected={branchFilter}
                  onChange={(v) => setBranchFilter(v as number[])}
                />
              </div>

              <div className="col-12 col-md-2">
                <div className="icon-form position-relative">
                  <span className="form-icon">
                    <i className="ti ti-calendar" />
                  </span>
                  <DateRangePicker
                    initialSettings={{
                      autoUpdateInput: false,
                      locale: { cancelLabel: "Clear" },
                    }}
                    onCallback={(start, end) => {
                      setStartDate(start.format("YYYY-MM-DD"));
                      setEndDate(end.format("YYYY-MM-DD"));
                      setCurrentPage(1);
                    }}
                    onCancel={() => {
                      setStartDate("");
                      setEndDate("");
                      setCurrentPage(1);
                    }}
                  >
                    <input
                      type="text"
                      className="form-control bookingrange"
                      placeholder="Select Date Range Filter"
                      value={
                        startDate && endDate
                          ? `${dayjs(startDate).format("DD-MM-YYYY")} - ${dayjs(
                              endDate,
                            ).format("DD-MM-YYYY")}`
                          : ""
                      }
                      readOnly
                      style={{ cursor: "pointer" }}
                      aria-label="Select date range"
                    />
                  </DateRangePicker>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Table Card */}
        <div className="card">
          <div className="card-body">
            <div className="table-responsive">
              {loading ? <Loader /> : <Table data={list} columns={columns} />}
            </div>
          </div>

          <Pagination
            currentPage={currentPage}
            perPage={perPage}
            totalItems={totalItems}
            onPageChange={(p) => {
              setCurrentPage(p);
              fetchList({ page: p, perPage, search: searchText });
            }}
            onPerPageChange={(pp) => {
              setPerPage(pp);
              setCurrentPage(1);
              fetchList({ page: 1, perPage: pp, search: searchText });
            }}
            perPageOptions={[
              { value: 5, label: "5" },
              { value: 10, label: "10" },
              { value: 25, label: "25" },
            ]}
          />
        </div>

        {/* Offcanvas Form */}
        <div
          className={`offcanvas offcanvas-end offcanvas-large ${
            showForm ? "show" : ""
          }`}
          style={{ visibility: showForm ? "visible" : "hidden" }}
          tabIndex={-1}
          role="dialog"
        >
          <div className="offcanvas-header border-bottom">
            <h5 className="fw-semibold">
              {selectedId ? "Update Customer" : "Add Customer"}
            </h5>
            <button
              type="button"
              className="btn-close"
              onClick={() => {
                setShowForm(false);
                setSelectedCountryName("India");
              }}
              disabled={submitting}
              aria-label="Close"
            >
              <i className="ti ti-x" />
            </button>
          </div>

          <div className="offcanvas-body">
            <form
              onSubmit={(e) => {
                e.preventDefault();
                if (!submitting) handleSubmit();
              }}
            >
              {/* Company / Customer */}
              <div className="row">
                <div className="col-md-6">
                  <div className="mb-3">
                    <label className="col-form-label">
                      Company Name <span className="text-danger">*</span>
                    </label>
                    <input
                      name="company_name"
                      type="text"
                      className="form-control"
                      value={formData.company_name}
                      onChange={inputChange}
                      disabled={submitting}
                      aria-label="Company Name"
                    />
                    {formError.company_name && (
                      <div className="invalid-feedback d-block text-danger">
                        {formError.company_name}
                      </div>
                    )}
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="mb-3">
                    <label className="col-form-label">
                      Customer Name <span className="text-danger">*</span>
                    </label>
                    <input
                      name="customer_name"
                      type="text"
                      className="form-control"
                      value={formData.customer_name}
                      onChange={inputChange}
                      disabled={submitting}
                      aria-label="Customer Name"
                    />
                    {formError.customer_name && (
                      <div className="invalid-feedback d-block text-danger">
                        {formError.customer_name}
                      </div>
                    )}
                  </div>
                </div>
              </div>

              {/* Owner & Classification */}
              <div className="row">
                <div className="col-md-6">
                  <div className="mb-3">
                    <label className="col-form-label">
                      Select Owner <span className="text-danger">*</span>
                    </label>
                    <Select
                      name="owner_id"
                      classNamePrefix="react-select"
                      className="tagging"
                      options={ownerList.map((b) => ({
                        value: b.id,
                        label: b.name,
                      }))}
                      value={
                        ownerList
                          .map((b) => ({ value: b.id, label: b.name }))
                          .find((o) => o?.value === formData.owner_id) || null
                      }
                      onChange={(selected) => {
                        setFormError((p) => {
                          const q = { ...p };
                          delete q.owner_id;
                          return q;
                        });
                        setFormData((prev: any) => ({
                          ...prev,
                          owner_id: selected?.value || null,
                        }));
                      }}
                      isClearable
                      isDisabled={submitting}
                    />
                    {formError.owner_id && (
                      <div className="invalid-feedback d-block text-danger">
                        {formError.owner_id}
                      </div>
                    )}
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="mb-3">
                    <label className="col-form-label">
                      Customer Classification{" "}
                      <span className="text-danger">*</span>
                    </label>
                    <Select
                      name="classification_id"
                      classNamePrefix="react-select"
                      className="tagging"
                      options={classificationList.map((b) => ({
                        value: b.id,
                        label: b.name,
                      }))}
                      value={
                        classificationList
                          .map((b) => ({ value: b.id, label: b.name }))
                          .find(
                            (o) => o?.value === formData.classification_id,
                          ) || null
                      }
                      onChange={(selected) => {
                        setFormError((p) => {
                          const q = { ...p };
                          delete q.classification_id;
                          return q;
                        });
                        setFormData((prev: any) => ({
                          ...prev,
                          classification_id: selected?.value || null,
                        }));
                      }}
                      isClearable
                      isDisabled={submitting}
                    />
                    {formError.classification_id && (
                      <div className="invalid-feedback d-block text-danger">
                        {formError.classification_id}
                      </div>
                    )}
                  </div>
                </div>
              </div>

              {/* Mobile / Landline */}
              <div className="row">
                <div className="col-md-6">
                  <div className="mb-3">
                    <label className="col-form-label">Mobile No.</label>
                    <input
                      name="mobile_no"
                      type="text"
                      className="form-control"
                      value={formData.mobile_no}
                      onChange={inputChange}
                      disabled={submitting}
                    />
                    {formError.mobile_no && (
                      <div className="invalid-feedback d-block text-danger">
                        {formError.mobile_no}
                      </div>
                    )}
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="mb-3">
                    <label className="col-form-label">Landline No.</label>
                    <input
                      name="landline_no"
                      type="text"
                      className="form-control"
                      value={formData.landline_no}
                      onChange={inputChange}
                      disabled={submitting}
                    />
                    {formError.landline_no && (
                      <div className="invalid-feedback d-block text-danger">
                        {formError.landline_no}
                      </div>
                    )}
                  </div>
                </div>
              </div>

              {/* Address */}
              <div className="mb-3">
                <label className="col-form-label">
                  Address <span className="text-danger">*</span>
                </label>
                <textarea
                  name="address"
                  className="form-control"
                  style={{ height: "120px" }}
                  value={formData.address}
                  onChange={inputChange}
                  disabled={submitting}
                />
                {formError.address && (
                  <div className="invalid-feedback d-block text-danger">
                    {formError.address}
                  </div>
                )}
              </div>

              {/* Pincode / City */}
              <div className="row">
                <div className="col-md-6">
                  <div className="mb-3">
                    <label className="col-form-label">
                      Pincode <span className="text-danger">*</span>
                    </label>
                    <input
                      name="pin_code"
                      className="form-control"
                      value={formData.pin_code}
                      onChange={inputChange}
                      disabled={submitting}
                    />
                    {formError.pin_code && (
                      <div className="invalid-feedback d-block text-danger">
                        {formError.pin_code}
                      </div>
                    )}
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="mb-3">
                    <label className="col-form-label">
                      City <span className="text-danger">*</span>
                    </label>
                    <input
                      name="city"
                      className="form-control"
                      value={formData.city}
                      onChange={inputChange}
                      disabled={submitting}
                    />
                    {formError.city && (
                      <div className="invalid-feedback d-block text-danger">
                        {formError.city}
                      </div>
                    )}
                  </div>
                </div>
              </div>

              {/* Country / State */}
              <div className="row">
                <div className="col-md-6">
                  <div className="mb-3">
                    <label className="col-form-label">
                      Country <span className="text-danger">*</span>
                    </label>
                    <Select
                      name="country_id"
                      classNamePrefix="react-select"
                      className="tagging"
                      options={countryList.map((b) => ({
                        value: b.id,
                        label: b.name,
                      }))}
                      value={
                        countryList
                          .map((b) => ({ value: b.id, label: b.name }))
                          .find((o) => o?.value === formData.country_id) || null
                      }
                      onChange={(selected) => {
                        setFormError((p) => {
                          const q = { ...p };
                          delete q.country_id;
                          return q;
                        });
                        const selectedLabel = selected?.label || "India";
                        const gstField = selectedLabel === "India";
                        setSelectedCountryName(selectedLabel);
                        setFormData((prev: any) => ({
                          ...prev,
                          state_dd: selectedLabel,
                          other_state_field: selectedLabel !== "India",
                          country_id: selected?.value || null,
                          gst_field: gstField,
                        }));
                      }}
                      isClearable
                      isDisabled={submitting}
                    />
                    {formError.country_id && (
                      <div className="invalid-feedback d-block text-danger">
                        {formError.country_id}
                      </div>
                    )}
                  </div>
                </div>

                {formData.state_dd === "India" ||
                selectedCountryName === "India" ? (
                  <div className="col-md-6">
                    <div className="mb-3">
                      <label className="col-form-label">
                        State <span className="text-danger">*</span>
                      </label>
                      <Select
                        name="state_id"
                        classNamePrefix="react-select"
                        className="tagging"
                        options={stateList.map((b) => ({
                          value: b.id,
                          label: b.name,
                        }))}
                        value={
                          stateList
                            .map((b) => ({ value: b.id, label: b.name }))
                            .find((o) => o?.value === formData.state_id) || null
                        }
                        onChange={(selected) => {
                          setFormError((p) => {
                            const q = { ...p };
                            delete q.state_id;
                            return q;
                          });
                          setFormData((prev: any) => ({
                            ...prev,
                            state_id: selected?.value || null,
                          }));
                        }}
                        isClearable
                        isDisabled={submitting}
                      />
                      {formError.state_id && (
                        <div className="invalid-feedback d-block text-danger">
                          {formError.state_id}
                        </div>
                      )}
                    </div>
                  </div>
                ) : (
                  <div className="col-md-6">
                    <div className="mb-3">
                      <label className="col-form-label">
                        Other State <span className="text-danger">*</span>
                      </label>
                      <input
                        name="other_state"
                        className="form-control"
                        value={formData.other_state}
                        onChange={inputChange}
                        disabled={submitting}
                      />
                      {formError.other_state && (
                        <div className="invalid-feedback d-block text-danger">
                          {formError.other_state}
                        </div>
                      )}
                    </div>
                  </div>
                )}
              </div>

              {/* Email / GST */}
              <div className="row">
                <div className="col-md-6">
                  <div className="mb-3">
                    <label className="col-form-label">
                      Email Id <span className="text-danger">*</span>
                    </label>
                    <input
                      name="email_id"
                      type="email"
                      className="form-control"
                      value={formData.email_id}
                      onChange={inputChange}
                      disabled={submitting}
                    />
                    {formError.email_id && (
                      <div className="invalid-feedback d-block text-danger">
                        {formError.email_id}
                      </div>
                    )}
                  </div>
                </div>

                {formData?.gst_field && (
                  <div className="col-md-6">
                    <div className="mb-3">
                      <label className="col-form-label">GST No.</label>
                      <input
                        name="gst_number"
                        type="text"
                        className="form-control"
                        value={formData.gst_number}
                        onChange={inputChange}
                        disabled={submitting}
                      />
                      {formError.gst_number && (
                        <div className="invalid-feedback d-block text-danger">
                          {formError.gst_number}
                        </div>
                      )}
                    </div>
                  </div>
                )}
              </div>

              <div className="d-flex justify-content-end">
                <button
                  type="button"
                  className="btn btn-soft-primary me-2"
                  onClick={() => {
                    setShowForm(false);
                    setSelectedCountryName("India");
                  }}
                  disabled={submitting}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="btn btn-soft-success"
                  disabled={submitting}
                >
                  {submitting
                    ? selectedId
                      ? "Updating..."
                      : "Creating..."
                    : selectedId
                      ? "Update"
                      : "Create"}
                </button>
              </div>
            </form>
          </div>
        </div>

        <Success
          id="formatSuccessModal"
          title="Customer"
          message={showMessage}
          show={showSuccess}
          onClose={() => setShowSuccess(false)}
        />

        <Delete
          show={showDeleteModal}
          title="Delete Customer?"
          message="Are you sure?"
          onConfirm={confirmDelete}
          onCancel={() => setShowDeleteModal(false)}
        />
      </div>
    </div>
  );
};

export default Customer;
